// Libraries
import React from 'react';

// Supermove
import {useNavigationDOM, useUrlFilters} from '@supermove/hooks';

// App
import SettingsSalesStagesPageContent from '@shared/modules/Settings/components/SettingsSalesStagesPageContent';
import ProjectSettingsPage from 'modules/Organization/Settings/Project/ProjectSettingsPage';

const ProjectSettingsPageStages = () => {
  const urlFilters = useUrlFilters({
    getRoute: () => '/settings/projects/stages',
    filterKeys: ['isArchived'],
  });

  const {navigator} = useNavigationDOM();

  return (
    <ProjectSettingsPage
      title='Sales Stages'
      description='Configure your sales stages to align with your workflow. Drag and drop to adjust the order, and preview how they will be displayed in the sales tab.'
      isCompanySettings
    >
      <SettingsSalesStagesPageContent
        isArchived={urlFilters.get('isArchived') === 'true'}
        setIsArchived={(isArchived) => urlFilters.handleUpdate({isArchived})}
        handleAdd={(projectStatus) => {
          navigator.push(`/settings/projects/stages/new/${projectStatus}`);
        }}
        handleView={(stageUuid) => {
          navigator.push(`/settings/projects/stages/${stageUuid}`);
        }}
      />
    </ProjectSettingsPage>
  );
};

export default ProjectSettingsPageStages;
